<template>
    <div>
        <!-- 广告 -->
        <div id="cellingAd" v-show="showAd" :style="{height:adHeight+'px'}" data-spm="fix-ad"></div>
        <div class="art-rec-news" :data-spm="spmC" data-spm-stop="init">
            <div class="rec__head" ref="recHeaderRef" :style="{'--fixTop':diffTop+'px'}">
                <div 
                    :class="['tab',(item.value==activeTab)&&'active']" 
                    v-for="item in tabList" 
                    @click="changeTab(item)"
                    :key="item.value"
                    >
                        {{item.name}}
                </div>
                <!-- 唤启app -->
                <transition name="fade-scale">
                    <div class="call-app" v-if="showCallApp" @click="openApp"></div>
                </transition>
            </div>
            <feed-list-new
                :key="activeTab"
                :article-id="articleId" 
                :businessConfig="businessConfig"
                :config="config">
            </feed-list-new>
        </div>
    </div>
</template>

<script>
import FeedListNew from './feed-list-new.vue'
import Util from '@/utils/util'
import { ceillingAd } from "@/ad/pages/articleAd.js";

const categoryId = window.cfgs?.category?.split("-")?.[1]

export default {
    name: "ArtFeed",
    props:{
        //文章ID
        articleId: {
            type: [Number, String],
            default: 0,
        },
    },
    components: {
        FeedListNew
    },
    data () {
        return {
            adDom: '', // 吸顶广告dom
            showAd: false, // 是否展示吸顶广告
            isCeilling: false, // 是否吸顶
            showCallApp: false, // 是否展示唤启app
            diffTop: 43, // 吸顶距离,受广告高度影响
            adHeight: 0, // 广告高度
            //通用参数map，传递给feed流封装组件
            config: {
                canFeedback: true, // 支持反馈弹框
                maxShowNumber: 40,//推荐阅读最大展示条数
                articleScene: 'normal' //普通文章页
            },
            // feed流的业务配置，视频是否大图
            businessConfig: {
                isBigVideoStyle: true
            },
            tabList: [
                {'name': '推荐阅读', id:1, 'value':'normal',spmC:'fd-d'},
                {'name': '编辑精选', id:2, 'value':'special',spmC:'fd-d-special'},
                // {'name': '国际新闻', id:3, 'value':'international',spmC:'fd-d-international'},
            ],
            activeTab: 'normal',
            spmC: 'fd-d'
        }
    },
    mounted () {
        window?.eventBus?.$on('ceillingAdData',this.getCeillingAdData) // 监听广告数据
        this.initAd()
        this.scrollInit() // 初始化滚动监听
    },
    watch: {
        adDom(_newVal) {
            // 存在吸顶广告的处理
            if(_newVal) {
               this.diffTop = this.diffTop + this.adHeight // 导航高度 + 广告高度 
               this.isCeilling = false
               this.$refs['recHeaderRef']?.classList.remove('rec_head_fixed')
                this.$refs['recHeaderRef']?.classList.remove('rec_head_top_fixed')
               this.handleCeilling()
            }
        },
        isCeilling(_newVal) {
            let CallAppBtnDom = document.querySelector("#CallAppContainer .btn")
            if(_newVal) {
                // 存在唤启app的处理
                if(CallAppBtnDom) {
                    this.showCallApp = true
                    CallAppBtnDom.style.display = 'none'
                }
            }else {
                this.showCallApp = false
                if(CallAppBtnDom) {
                    CallAppBtnDom.style.display = 'block'
                }
            }
        }
    },
    methods: {
        initAd() {
            const testParam = window.AB_TEST?.recommendtab
            const isTestNoAd = testParam == 1 // 不展示广告
            const isTestBigAd = testParam == 2 // 展示大图广告
            const isTestLittlAd = testParam == 3 // 展示小图广告

            if(isTestBigAd)this.adHeight = 217
            if(isTestLittlAd)this.adHeight = 77

            if(window.cfgs?.Sgrade == 0 && !isTestNoAd)ceillingAd(testParam)

        },
        // 获取广告数据
        getCeillingAdData(adData) {
            this.adDom = adData
        },
        // 初始化滚动监听
        scrollInit () {
            window.addEventListener('scroll', Util.throttle((e) => {
                this.handleCeilling()
            }, 200));
        },  
        handleCeilling() {
            let artRecNewsDom = document.querySelector("#artRecNews")
            let top = artRecNewsDom.getBoundingClientRect().top

            // 吸顶处理
            if(top <= this.diffTop) {
                if(this.isCeilling) return
                this.isCeilling = true
                // 存在广告的处理
                if(this.adDom) {
                    this.showAd = true
                    document.querySelector("#cellingAd")?.appendChild(this.adDom)
                    this.$nextTick(()=>{
                        window.sohuSpm.domDidChange({ target: "fix-ad" })
                    })
                    this.$refs['recHeaderRef']?.classList.add('rec_head_fixed')
                }else { // 不存在广告的处理
                    this.$refs['recHeaderRef']?.classList.add('rec_head_top_fixed')
                }
            }else { // 非吸顶处理
                if(!this.isCeilling) return
                this.isCeilling = false
                this.showAd = false
                this.$refs['recHeaderRef']?.classList.remove('rec_head_fixed')
                this.$refs['recHeaderRef']?.classList.remove('rec_head_top_fixed')
            }
        },      
        // 切换标签
        changeTab(item) {
            let tab = item.value
            if(this.activeTab == tab) {
                return 
            }
            window.sohuSpm?.sendAction({
                acode: 10967,
                clkParam: `tab:${item.id};`,
            });
            this.config.articleScene = tab
            this.activeTab = tab
            this.spmC = item.spmC
            let artRecNewsDom = document.querySelector("#artRecNews")
            const rect = artRecNewsDom.getBoundingClientRect();
            const scrollTop = rect.top + window.pageYOffset; 
            window.scrollTo({
                top: scrollTop - this.diffTop + 2, // 2px保持吸顶状态
                behavior:'smooth'
            })
        },
        // 唤启app
        openApp() {
            window?.EVENT_BUS?.$emit('openApp')
        }
    }
}
</script>

<style lang="less" rel="stylesheet/less">
    #cellingAd {
        position: fixed;
        width: 100%;
        left: 0;
        top: 88px;/*px*/
        background: white;
        display: flex;
        align-items: center;
        z-index: 100;
    }
    .art-rec-news {
        padding-top: 96px; /*px*/
        padding-bottom: 12px;/*px*/
        border-bottom: 8px solid #f5f5f5;/*px*/
        position: relative;
        .feed-list-area-feed {
            padding: 0;
            .feed-item {
                border: 0;
            }
        }
        /* 定义进入和离开的过渡效果，增加了缩放和移动 */
        .fade-scale-enter-active, .fade-scale-leave-active {
            transition: all 0.4s ease;
        }
        .fade-scale-enter, .fade-scale-leave-to {
            opacity: 0;
            transform: scale(0.5);
        }
    }
    .rec__head {
        position: absolute;
        left: 0;
        top: 0;
        height: 96px; /*px*/
        padding-left: 26px; /*px*/
        padding-right: 26px; /*px*/
        padding-top: 0px;
        padding-bottom: 0px;
        display: flex;
        align-items: center;
        box-shadow: inset 0px -2px 0px 0px #F2F2F2;/*px*/
        width: 100%;
        box-sizing: border-box;
        background: white;
        justify-content: flex-start;
        .tab {
            width: 160px;/*px*/
            height: 56px;/*px*/
            background: #F2F2F2;
            border-radius: 8px;/*px*/
            font-weight: 500;
            font-size: 28px;/*px*/
            color: #111111;
            text-align: left;
            font-style: normal;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;/*px*/
        }
        .active {
            background: #111111;
            color: #FFFFFF;
        }
        .call-app {
            width: 160px;/*px*/
            height: 52px;/*px*/
            // border-radius: 12px;/*px*/
            background-image: url('../less/images/open-app-yellow@2x.png');
            background-size: 100% 100% ;
            margin-left: auto;
        }
    }
    // 存在吸顶广告的处理
    .rec_head_fixed {
        position: fixed;
        top: var(--fixTop);/*px*/
        left: 0;
        z-index: 999;
    }
    //不存在吸顶广告的处理
    .rec_head_top_fixed {
        position: fixed;
        top: 86px;/*px*/
        left: 0;
        z-index: 999;
    }
</style>